import { Flex, Grid, GridItem, Heading, ListItem, Text, UnorderedList } from "@chakra-ui/react";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useGetIssbMetrics } from "../../../../../hooks/query";
import { H2 } from "components/text/headings";

function StepThree({ data }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "issbPlan.planDetails.modals.stepThree",
  });
  const { t: globalTranslation } = useTranslation("translation");

  const { data: metricsData } = useGetIssbMetrics(data.subIndustries[0], {
    enabled: data?.subIndustries?.length > 0,
  });

  const gridAttributes = ["topic", "metric", "category", "unit", "code"];

  const renderHeadingGridItems = () => {
    return gridAttributes.map((attr) => {
      return (
        <GridItem key={`heading-${attr}`} borderWidth={"1px"} pl="4" pr="4" pt="2" pb="2">
          <Heading marginBlock="1" size="sm">
            {t(`gridHeaders.${attr}`)}
          </Heading>
        </GridItem>
      );
    });
  };

  const renderMetricsGridItems = () => {
    return metricsData.map((el) => {
      return (
        <Fragment key={el.id}>
          {gridAttributes.map((attr) => {
            return (
              <GridItem key={`${attr}-${el.id}`} borderWidth={"1px"} pl="4" pr="4" pt="2" pb="2">
                <Text marginBlock="1" size="sm">
                  {el[attr]}
                </Text>
              </GridItem>
            );
          })}
        </Fragment>
      );
    });
  };

  return (
    <>
      <Heading size="lg" marginBottom={5}>
        {t("title")}
      </Heading>
      <Text fontSize="xl" fontWeight="bold" marginBottom={2}>
        {t("context")}
      </Text>
      <Text fontSize="lg" marginBottom={2}>
        {t("contextContent")}
      </Text>
      <Text fontSize="lg" fontWeight={600} marginBottom={4}>
        {t("notaBene")}
      </Text>
      <Text fontSize="xl" fontWeight="bold" marginBottom={2}>
        {t("actions")}
      </Text>
      <UnorderedList marginBottom={8}>
        <ListItem>
          <Text fontSize="lg">{t("actionsContent")}</Text>
        </ListItem>
      </UnorderedList>
      <Flex marginBottom={2} gap={1}>
        <H2>{t("sector")}</H2>
        <Text fontSize="lg" marginRight={8}>
          {`- ${globalTranslation(`issbPlan.companyDetails.options.companyIndustry.${data.companyIndustry}`, {
            defaultValue: data.companyIndustry,
          })}`}
        </Text>
        <H2>{t("subSector")}</H2>
        <Text fontSize="lg">
          {`- ${globalTranslation(
            `issbPlan.companyDetails.options.subIndustries.${data.companyIndustry}.${metricsData?.[0]?.subIndustry}`,
            { defaultValue: metricsData?.[0]?.subIndustry ?? data.subIndustries[0] }
          )}`}
        </Text>
      </Flex>
      <Grid templateColumns="repeat(5, 1fr)" overflow="auto" marginBottom={4}>
        {renderHeadingGridItems()}
        {metricsData ? renderMetricsGridItems() : null}
      </Grid>
    </>
  );
}

export default StepThree;
